import { EventStatus } from 'lane-shared/domains/visitorManagement/types';

import { ChipStyle } from 'components/ads/chipSelect/types';
import type { ChipListItem } from 'components/ads/chipSelect/types';

export type StatusListItem = ChipListItem & { key: string };

export const StatusListItems: Readonly<StatusListItem[]> = Object.freeze([
  {
    key: 'pendingStatus',
    label: 'web.admin.channel.visitor.log.status.pending',
    value: EventStatus.EVENT_STATUS_PENDING,
    type: ChipStyle.Pink,
  },
  {
    key: 'upcomingStatus',
    label: 'web.admin.channel.visitor.log.status.upcoming',
    value: EventStatus.EVENT_STATUS_UPCOMING,
    type: ChipStyle.Yellow,
  },
  {
    key: 'validatedStatus',
    label: 'web.admin.channel.visitor.log.status.validated',
    value: EventStatus.EVENT_STATUS_VALIDATED,
    type: ChipStyle.White,
  },
  {
    key: 'checkedInStatus',
    label: 'web.admin.channel.visitor.log.status.checkedIn',
    value: EventStatus.EVENT_STATUS_CHECKED_IN,
    type: ChipStyle.Green,
  },
  {
    key: 'checkedOutStatus',
    label: 'web.admin.channel.visitor.log.status.checkedOut',
    value: EventStatus.EVENT_STATUS_CHECKED_OUT,
    type: ChipStyle.Blue,
  },
  {
    key: 'noShowStatus',
    label: 'web.admin.channel.visitor.log.status.noShow',
    value: EventStatus.EVENT_STATUS_NO_SHOW,
    type: ChipStyle.Grey,
  },
  {
    key: 'cancelledStatus',
    label: 'web.admin.channel.visitor.log.status.cancelled',
    value: EventStatus.EVENT_STATUS_CANCELLED,
    type: ChipStyle.Red,
  },
  {
    key: 'withdrawnStatus',
    label: 'web.admin.channel.visitor.log.status.withdrawn',
    value: EventStatus.EVENT_STATUS_WITHDRAWN,
    type: ChipStyle.Red,
  },
  {
    key: 'expiredStatus',
    label: 'web.admin.channel.visitor.log.status.expired',
    value: EventStatus.EVENT_STATUS_EXPIRED,
    type: ChipStyle.Blue,
  },
  {
    key: 'rejectedStatus',
    label: 'web.admin.channel.visitor.log.status.rejected',
    value: EventStatus.EVENT_STATUS_REJECTED,
    type: ChipStyle.Red,
  },
  {
    key: 'failedStatus',
    label: 'web.admin.channel.visitor.log.status.failed',
    value: EventStatus.EVENT_STATUS_FAILED,
    type: ChipStyle.Red,
  },
]);

const statusListMap: { [key: string]: string } = {};

for (const statusList of StatusListItems) {
  statusListMap[statusList.value] = statusList.label;
}

export const StatusKeyToLabelForExport = statusListMap;
export const StatusKeyToLabelForStatusUpdate = statusListMap;
